import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { asyncScheduler, combineLatest, from, iif, interval, merge, Observable, of, Subject } from 'rxjs';
import {
  delay,
  distinctUntilChanged,
  distinctUntilKeyChanged,
  endWith,
  map,
  skipWhile,
  startWith,
  switchMap,
  takeUntil,
  takeWhile,
  tap,
} from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsHeaderLabels } from '../../../../shared/enums/analytics.enum';
import { IGNORE } from '../../../../shared/enums/versiones';
import { NativeStorageNamesV2 } from '../../../../shared/models/Constants';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { SharedServiceService } from '../../../../shared/services/shared-service.service';
import { extrasLives, sendStatusLifesModal } from '../../../../store/actions';
import { AppState } from '../../../../store/app-reducers';
import { IGetStatus } from '../../../../store/reducers';
import { TransferDataService } from '../../services/transfer-data.service';
import { StorageData } from './../../../../shared/services/utilities/storage-data.class';
import { MenuHeader } from './../../models/menu-item';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() titulo: string = ''
  @Input() defaulrUrl? = ''
  @Input() tienda? = false
  @Input() disableBackButton? = null
  @Input() pushToolbar? = { toolbar: '', module: '' }
  @Input() help? = false
  @Input() titleSize?: string = '0px'

  @Output() ayuda = new EventEmitter<true>()

  public menuHamburguer = false
  public showBackArrow = false
  public isBadge = false;
  public isGame = false;
  public isPopup = false;
  public isPopupStatus = false;
  public isViewBottons = false;
  public isProd = environment.production;
  public labelDebug = environment.env;
  public borderHeader = ''
  public livesEarn = '';
  public colors: { colorToolbar: string, iconBack: string, classText: string } = { colorToolbar: 'mycolorWhite', iconBack: 'previus-blue', classText: 'navbar-title-blue' };
  public bellUrl = './assets/icon/bell-icon.svg'
  public MenuHeader: Observable<MenuHeader[]>;
  // public backDefaultHref = ''
  public toolbarWhiteBell: string[] = [
    'Mis Compras',
    'Mi Historial',
    'Portafolio',
    'Portafolio que no te puede faltar',
    'Programa',
    'Promociones',
    'Más',
    'Tienda',
    'Para Ti',
    'Autoevaluación',
    'Centro de asistencia',
  ]
  public toolbarBlueBack: string[] = [
    'Noticias'
    , 'Contacto'
    , 'Notificaciones'
    , 'Mi Perfil'
    , 'Crece Más'
    , 'Juegos'
  ]
  public toolbarWhiteBack: string[] = [
    'Mis Logros'
    , 'Mecánica'
    , 'Preventa'
    , 'Última Preventa'
    , 'Ticket de Entrega'
    , 'Mi Carrito'
  ]
  private noticias = 'Noticias'
  private titleTienda = 'Tienda'
  private storageBodegaNud = NativeStorageNamesV2.BodegaNud

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private nav: NavController
    , private store: Store<AppState>
    , private sharedS: SharedServiceService
    , private analytS: AnalyticsService
    , private translate: TranslateService
    , public transferDataS: TransferDataService
    , private sharedAnalyticsS: SharedAnalyticsService
  ) {
    this.MenuHeader = this.store.select('userData').pipe(map(value => value.MenuHeader));
  }

  async ngOnInit() {
    const title: string = this.translate.instant('Titles.success-photo');
    const isMenuHamEje$ = this.sharedS.menuTabState
      .pipe(
        map(menuTabs => menuTabs.filter(tab => tab.title === title).length === 0)
      );
    combineLatest([this.transferDataS.temporizador$, isMenuHamEje$])
      .pipe(
        map(isBadge => isBadge[0] && isBadge[1]),
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackTimer);

    if (this.pushToolbar?.module !== '' && this.pushToolbar?.toolbar !== '') {
      (this as any)[this.pushToolbar?.toolbar || ''].push(this.pushToolbar?.module);
    }

    this.sharedS.menuVisibleState
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(this.calbackNextmenuVisible);

    if (this.tienda) {
      const index = this.toolbarWhiteBell.indexOf(this.titleTienda)
      this.toolbarWhiteBell.splice(index, 1)
      this.toolbarWhiteBack.unshift(this.titleTienda)
    }
    this.obtieneBodegaNud();

    if (this.toolbarWhiteBack.includes(this.titulo)) {
      this.sharedS.emitMenu(false)
    }
    this.disableBackButton = null

    this.toolbar();
  }

  async ngAfterViewInit(): Promise<void> {
    const isIgnore = await IGNORE();
    this.isGame = isIgnore ? false : this.toolbarWhiteBell.some(title => title === this.titulo);
    this.isViewBottons = this.toolbarWhiteBell.some(title => title === this.titulo);

    const isLoadingTop$ = interval(1000).pipe(
      startWith(0),
      switchMap(() => from(this.sharedS.loadingGetop())),
      skipWhile(value => typeof value === 'undefined'),
      takeWhile(value => !(typeof value === 'undefined')),
      map(value => value ? true : false),
      endWith(false),
      distinctUntilChanged(),
    );

    const extrasLifes$ = this.store.select('extrasLives')
      .pipe(
        map(value => value.VidasGanadas),
        switchMap(lives => of(lives).pipe(skipWhile(l => l < 1))),
        map(lives => ({ status: true, visible: true, lives: `+${lives}`, reason: 3 }))
      );
    const lifes$ = this.store.select('StatusLifesModal')
      .pipe(
        map(value => value.GetStatus),
        distinctUntilKeyChanged('status'),
        switchMap(this.callbackSwitchMapLifesModal),
      );
    const lifesView$ = merge(lifes$, extrasLifes$).pipe(
      switchMap(activePopup => iif(() => !this.isGame
        , of({ status: false, visible: false, lives: '', reason: 0 })
        , of(activePopup)
      )
      )
    );

    combineLatest([lifesView$, isLoadingTop$])
      .pipe(
        switchMap(obs => of(obs[1]).pipe(skipWhile(x => x), map(() => obs[0]))),
        tap(popup => this.isPopup = popup.visible),
        delay(1000),
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackStatusLifesModal);
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
    if (!this.toolbarWhiteBell.includes(this.titulo)) {
      this.sharedS.emitMenu(true)
    }
  }

  /**
   * Pone el temporizador del menu de foto de exito
   */
  private callbackTimer = (time: boolean) => this.isBadge = time;

  private calbackNextmenuVisible = (visible: boolean) => this.menuHamburguer = visible;

  private callbackSwitchMapLifesModal = (resp: IGetStatus) =>
    this.translate.get('Miscellaneous.popup-daily-lives')
      .pipe(map((popup: boolean) =>
      ({
        status: resp.status === 2 && popup,
        visible: this.isGame && resp.status === 2 && popup,
        lives: '',
        reason: resp.status
      }))
      );

  /**
   * Callback para validar si se aparece el popup de vidas diarias
   */
  private callbackStatusLifesModal = (popup: ILivesReason) => {
    this.isPopupStatus = popup.status;
    this.livesEarn = popup.reason === 3 ? popup.lives : this.translate.instant('Labels.more-life');
    if (popup.status) {
      const timePopup: number = this.translate.instant('Miscellaneous.popup-daily-lives-time');
      asyncScheduler.schedule(() => this.isPopupStatus = false, timePopup);
      asyncScheduler.schedule(() => {
        this.isPopup = false;
        switch (popup.reason) {
          case 2:
            this.store.dispatch(sendStatusLifesModal({ status: 0 }));
            break;
          case 3:
            this.store.dispatch(extrasLives({ VidasGanadas: 0 }));
            break;
        }
      }, (timePopup + 750));
    }
  }

  /**
   * Valida que icono del header selecciono
   * @param module objeto del la opcion del header
   */
  public onModule = async (module: MenuHeader) => {
    this.nav.navigateForward([module.route], { animated: true, animationDirection: 'forward' });
    switch (module.tab) {
      case 'notificationes':
        this.sharedS.emitMenu(false);
        this.sharedAnalyticsS.trackInteractionHeader({
          section: this.titulo,
          label: EAnalyticsHeaderLabels.NOTIFICACIONES
        });
        break;
      case 'juegos':
        this.sharedAnalyticsS.trackInteractionHeader({
          section: this.titulo,
          label: EAnalyticsHeaderLabels.JUEGOS
        });
        break;
      case 'Impulsa-GEPP':
        this.sharedAnalyticsS.trackInteractionHeader({
          section: this.titulo,
          label: EAnalyticsHeaderLabels.IMPULSA_GEPP
        });
        break;
      default:
        break;
    }
  }

  private async obtieneBodegaNud() {
    const obtieneNativeStorage = await StorageData.getDataStorage(this.storageBodegaNud);

    if (obtieneNativeStorage[2] === 0) {
      const index = this.toolbarBlueBack.indexOf(this.noticias)
      this.toolbarBlueBack.splice(index, 1)
      this.toolbarWhiteBell.unshift(this.noticias)
    }
  }

  private toolbar() {
    if (this.toolbarWhiteBell.find(x => x === this.titulo) !== undefined) {
      this.colors = {
        colorToolbar: 'mycolorWhite'
        , iconBack: 'previus-blue'
        , classText: 'navbar-title-blue'
      }
      this.showBackArrow = false
    } else if (this.toolbarWhiteBack.find(x => x === this.titulo) !== undefined) {
      this.colors = {
        colorToolbar: 'mycolorWhite'
        , iconBack: 'previus-blue'
        , classText: 'navbar-title-blue'
      }
      this.showBackArrow = true
    } else if (this.toolbarBlueBack.find(x => x === this.titulo) !== undefined) {
      this.colors = {
        colorToolbar: 'mycolorBlue'
        , iconBack: 'previus-white'
        , classText: 'navbar-title-white'
      }
      this.borderHeader = 'border-header'
      this.showBackArrow = true
    }

    if (this.disableBackButton) {
      this.showBackArrow = false
    }
  }

  public async onAnalytic(seccion: string, parametro: string) {
    this.sharedAnalyticsS.trackInteractionHeader({
      section: seccion,
      label: parametro
    });
    if (parametro === 'atras') {
      this.tienda ?
        this.nav.navigateBack([`/Productos`], { animated: true, animationDirection: 'back' })
        : this.nav.back({ animated: true, animationDirection: 'back' });
    }

  }

  public onHelp = () => {
    this.sharedAnalyticsS.trackInteractionHeader({
      section: this.titulo,
      label: EAnalyticsHeaderLabels.AYUDA
    });
    this.ayuda.emit(true);
  };

}

interface ILivesReason {
  status: boolean;
  visible: boolean;
  lives: string;
  reason: number;
}
